import React from "react"
import {  
    Grid,
    Typography,
   } from "@material-ui/core"
import "./style.scss"
import _ from 'lodash'

const SubPageBanner = ({webbannerimg,mobbannerimg,bannerHeading,bannerContent,buttonClick,buttonText})=>{
    return(<>
           <Grid container direction="row" spacing={2} className="bannerstyle" style={{ marginTop:  _.isEqual(bannerHeading, 'Flexible Collaboration') && "-2px" }}>
                        <Grid item xs={12} md={6} sm={6}>                       
                         <img  src={webbannerimg} alt='webimg' className="bannerImageStyle webbannerImage" style={{ padding: _.isEqual(bannerHeading, 'Data Management') ? '10px 115px 0px 80px' : '79px 115px 0px 0px' }} />
                         <img  src={mobbannerimg} alt='mobimg' className="mobbannerImage "  />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} style={{ display: 'flex', alignItems: 'center'}}>
                            <div className="headerBanner">
                                <Typography variant="h5" className="bannerHeading">{bannerHeading}</Typography>
                                <Typography className="bannerContent">{bannerContent}</Typography>
                                <button onClick={buttonClick} className="bannerButtonStyle" style={{ marginBottom: '1rem' }}>{buttonText} </button>
                            </div>
                        </Grid>
                    </Grid>
                    </>
                    )    
                }
export default SubPageBanner